import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon, ArrowUpRightIcon } from 'lucide-react';
import { serviceMenuItems } from '../../data/navigation';
import { isExternalUrl, linkTargetProps } from '../../utils/links';
import { urls } from '../../data/site';
interface ServicesMenuProps {
  id: string;
  onNavigate: () => void;
}
export function ServicesMenu({
  id,
  onNavigate
}: ServicesMenuProps) {
  const reduce = useReducedMotion();
  return <motion.div id={id} initial={{
    opacity: 0,
    y: reduce ? 0 : -6
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: reduce ? 0 : -4
  }} transition={{
    duration: 0.18,
    ease: [0.23, 1, 0.32, 1]
  }} className="absolute left-0 top-full z-50 mt-3 w-[460px] border border-line bg-paper-bright shadow-[0_24px_48px_-24px_rgba(23,23,25,0.35)]" data-id="element-436" data-mp="ac1xv6zx8uhp">
      <div aria-hidden="true" className="h-[3px] w-14 bg-brand" data-id="element-437" data-mp="3sj7slan4oxmb" />
      <ul className="py-2" data-id="element-438" data-mp="3nitx0s2prg56">
        {serviceMenuItems.map(item => {
        const external = isExternalUrl(item.href);
        return <li key={item.label} data-id="element-439" data-mp="hctwj06h4a80">
              <a href={item.href} onClick={onNavigate} {...linkTargetProps(item.href)} className="group flex items-start justify-between gap-6 px-6 py-3.5 transition-colors duration-150 ease-out hover:bg-paper-deep" data-id="element-440" data-mp="he5a1rpq0wcb">
                <span data-id="element-441" data-mp="vdy0rn18zcka">
                  <span className="block font-display text-[19px] font-semibold uppercase tracking-[0.03em] text-ink" data-id="element-442" data-mp="vdejm8jf8s7b">
                    {item.label}
                  </span>
                  <span className="mt-0.5 block text-sm text-steel" data-id="element-443" data-mp="mb593io5kytx">{item.description}</span>
                </span>
                {external ? <ArrowUpRightIcon aria-hidden="true" className="mt-1 h-4 w-4 shrink-0 text-steel transition-colors duration-150 ease-out group-hover:text-brand" data-id="element-444" data-mp="rd4d8urpvzrx" /> : <ArrowRightIcon aria-hidden="true" className="mt-1 h-4 w-4 shrink-0 text-steel transition-colors duration-150 ease-out group-hover:text-brand" data-id="element-445" data-mp="1hk8rfiduy1xy" />}
              </a>
            </li>;
      })}
      </ul>
      <a href={urls.services} onClick={onNavigate} className="flex items-center justify-between border-t border-line px-6 py-4 text-sm font-semibold text-ink transition-colors duration-150 ease-out hover:text-brand-deep" data-id="element-446" data-mp="13su9zfzlm8t0">
        View all services
        <ArrowRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-447" data-mp="ow37gxumogz6" />
      </a>
    </motion.div>;
}